import React from "react";
import styled from "styled-components";
import { useRequest } from "../../fetchboi/hooks";
import Layout from "../../components/Layout";
import { Col, Grid, Row } from "rsuite";
import { motion } from "framer-motion";
import SponsorCard from "./SponsorCard";
import Icon from "../../components/Icon";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function Sponsors() {
  const [sponsors, loading] = useRequest({ url: "/sponsors" });

  return (
    <Layout.Container>
      <Container>
        <Layout.Title>Sponsors</Layout.Title>
        <Layout.Loader loading={loading} />
        {sponsors ? (
          <Grid fluid>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <Row gutter={24}>
                {sponsors.map((sponsor, index) => (
                  <Col key={index} xs={24} sm={12} md={8} lg={6}>
                    <motion.div variants={itemVariants}>
                      <SponsorCard
                        id={sponsor.ID}
                        name={sponsor.Name}
                        imageURL={sponsor.ImageURL}
                        clickable={!!sponsor.Description}
                      />
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          </Grid>
        ) : null}
        {(!sponsors || sponsors.length === 0) && !loading ? (
          <Row gutter={32}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <Col md={8}>
                <Icon icon="megaphone" size={16} />
                <span style={{ marginLeft: 4 }}>
                  ¡Pronto publicaremos la información!
                </span>
              </Col>
            </motion.div>
          </Row>
        ) : null}
      </Container>
    </Layout.Container>
  );
}

const Container = styled.div``;
